import React, { useEffect, useState } from 'react';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';
import { useParams } from 'react-router-dom';
import { usePropertyStore } from '@stores/Property/Property';
import { IAuthenticatedPropertyDetails } from '@stores/Property/types';
import PropertyDetailsCard from '@components/PropertyDetailsCard';
import Loading from '@components/Loading/Loading';

export function AtuthenticatedDetailsScreen() {
  const { id } = useParams<{ id?: string }>();
  const { fetchAuthenticatedPropertyDetails } = usePropertyStore();
  const [property, setProperty] =
    useState<IAuthenticatedPropertyDetails | null>(null);
  const [shouldFetch, setShouldFetch] = useState(true);

  // Load if editing
  useEffect(() => {
    const loadProperty = async () => {
      if (id) {
        const propertyId = parseInt(id, 10);
        const propertyDetails =
          await fetchAuthenticatedPropertyDetails(propertyId);
        console.log(propertyDetails);
        if (propertyDetails) {
          setProperty((prev) => ({ ...prev, ...propertyDetails }));
        }
      }
    };
    if (shouldFetch) {
      loadProperty();
    }
  }, [id, shouldFetch, fetchAuthenticatedPropertyDetails]);

  useEffect(() => {
    setShouldFetch(property === null);
  }, [property]);

  if (!property) {
    return <Loading />;
  }

  return (
    <AuthenticatedLayout>
      <PropertyDetailsCard key={id} property={property} />
    </AuthenticatedLayout>
  );
}
